import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import logoUrl from './logo.jpg';
import BreadCrumb from './breadCrumb';
import UserInfo from './userInfo';
import errorBoundary from '@ifeng/errorBoundary';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
import { rel } from '../../../../utils/rel';

class Header extends React.PureComponent {
    static propTypes = {
        headerData: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { headerData } = this.props;

        return (
            <div>
                <div className={styles.header}>
                    <div className={styles.logo}>
                        <a href="//www.ifeng.com/" rel={rel}>
                            <LazyImg src={logoUrl} />
                        </a>
                    </div>
                    <BreadCrumb headerData={headerData} />
                    <UserInfo />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
